import { blackColors, whiteColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const tabsWithDotsStyle = (theme) => ({
	menuWrapper: {
		display: 'flex',
		justifyContent: 'center',
	},
	dotWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		height: '36px',
	},
	text: {
		position: 'absolute',
		top: '20px',
		minWidth: '72px',
		textAlign: 'center',
	},
	activeDotWrapper: {
		cursor: 'pointer',
	},
	dot: {
		width: '16px',
		height: '16px',
		borderRadius: '8px',
		border: '2px solid #979797',
		marginBottom: '4px',
	},
	activeDot: {
		backgroundColor: theme.palette.primary.main,
		border: 'none',
	},
	currentActiveDot: {
		background: 'transparent',
		border: `2px solid ${theme.palette.primary.main}`,
	},
	line: {
		width: '90px',
		height: '2px',
		backgroundColor: '#979797',
		position: 'relative',
		top: '7px',
	},
	withLine: {
		display: 'flex',
	},
	activePTag: {
		'& > p': {
			color: `${blackColors[1]}!important`,
		},
	},
	scrollWrapper: {
		maxWidth: '100%',
		margin: '0 auto',
		userSelect: 'none',
		minHeight: 65,
		'&::-webkit-scrollbar-thumb': {
			display: 'none',
		},
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	activeLine: {
		backgroundColor: theme.palette.primary.main,
	},
	loadingWrapper: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		background: `rgba(${hexToRgb(whiteColor)}, 0.9)`,
	},
	lockIcon: {
		color: blackColors[3],
		position: 'relative',
		bottom: 3,
		width: 20,
	},
	lockIconActive: {
		color: theme.palette.primary.main,
	},
});

export default tabsWithDotsStyle;
